import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import { ImageItem } from "@/models/images/image.item"


const __default__ = {
  name: "ImageViewPopup"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  image: {
    type: Object as PropType<ImageItem>
  }
},
  setup(__props, { expose }) {
  expose();

const props = __props



const getImageUrl = (id: string) => {
  return `/api/v1/images/${id}`
}

const __returned__ = { props, getImageUrl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})